// import { UserExamList } from '@/types';
// import moment from 'moment';

// // 计算时间是在当天内、当天之后还是当天之前
// const getContestStatus = (startTime: number, endTime: number) => {
//   const now = moment().utcOffset(8).startOf('day');
//   // 模拟赛不存在 startTime 所以要设置一个默认值
//   const defaultStartTime = now.valueOf() - 1000 * 3600;
//   const start = moment(startTime || defaultStartTime)
//     .utcOffset(8)
//     .startOf('day');
//   const end = moment(endTime).utcOffset(8).startOf('day');
//   if (now.isAfter(start) && now.isSameOrBefore(end)) {
//     return 'inProgressState';
//   } else if (now.isBefore(start)) {
//     return 'waiteState';
//   } else if (now.isAfter(end)) {
//     return 'endState';
//   }
// };

export interface IContestStatus {
  [key: string]: {
    text: string;
    status: number;
    attr: string;
  };
}

export const StateMap = {
  inProgressState: {
    text: '进行中',
    status: 1,
    attr: 'inProgressState',
  },
  waitState: {
    text: '待开始',
    status: 0,
    attr: 'waitState',
  },
  endState: {
    text: '已结束',
    status: 2,
    attr: 'endState',
  },
};

// export const DealContestListWithStatus = (list: UserExamList) => {
//   const statusMap: IContestStatus = {
//     waiteState: {
//       text: '待开始',
//       color: '#FFA500',
//       list: [],
//     },
//     inProgressState: {
//       text: '进行中',
//       color: '#FF0000',
//       list: [],
//     },
//     endState: {
//       text: '已结束',
//       color: '#00FF00',
//       list: [],
//     },
//   };
//   for (let i = 0; i < list.length; i++) {
//     const { startTime, endTime } = list[i];
//     const status = getContestStatus(startTime, endTime);
//     if (status && statusMap[status]) {
//       statusMap[status].list.push(list[i]);
//     }
//   }
//   return statusMap;
// };
